import * as React from "react";
import classnames from "classnames";
import { ConfiguratorModal } from "../../../ConfiguratorModal/components/ConfiguratorModal/ConfiguratorModal.js";
import { ConfiguratorStepContainer } from "../../../ConfiguratorStep/components/ConfiguratorStep/ConfiguratorStepContainer.js";
import { ConfiguratorFooter } from "../../../Footer/components/Footer/ConfiguratorFooter.js";
import { ConfiguratorHeaderContainer } from "../../../Header/components/Header/ConfiguratorHeaderContainer.js";
import { ConfiguratorMainContainer } from "../../../Main/components/Main/ConfiguratorMainContainer.js";
/* empty css                  */
const Configurator = ({
  "data-t": dataT,
  className,
  isOpen,
  preventVerticalScroll
}) => /* @__PURE__ */ React.createElement(ConfiguratorModal, { isOpen, preventVerticalScroll }, /* @__PURE__ */ React.createElement("div", { "data-t": dataT, className: classnames("configurator", className) }, /* @__PURE__ */ React.createElement(ConfiguratorHeaderContainer, null), /* @__PURE__ */ React.createElement(ConfiguratorMainContainer, { className: "configurator__main" }, /* @__PURE__ */ React.createElement(ConfiguratorStepContainer, null)), /* @__PURE__ */ React.createElement(ConfiguratorFooter, null)));
export {
  Configurator
};
//# sourceMappingURL=Configurator.js.map
